import { Box, Stack, Typography } from '@mui/material'
import { paletteColorsDark } from 'src/theme'
import { TourDefinition } from '../types'

// Created via Playwright MCP exploration of the self-paced home, AppBar, and profile pages.
// data-tour targets:
//   "profile-menu-button"        — AppBar profile avatar (base-layout.tsx)
//   "profile-account-details-tab" — Account Details tab (profile/v4/layout.tsx)
//   "profile-licenses-tab"        — Licenses & Certifications tab (profile/v4/layout.tsx)

let WelcomeContent = () => (
  <Stack spacing={2}>
    <Typography
      variant="body2"
      sx={{ color: paletteColorsDark.text, lineHeight: 1.75, opacity: 0.9 }}
    >
      FOAMfrat Studio helps EMS and Nursing clinicians earn and track continuing
      education credits — all in one place.
    </Typography>

    <Box
      sx={{
        borderLeft: `3px solid ${paletteColorsDark.primary}`,
        pl: 1.5,
      }}
    >
      <Typography
        variant="body2"
        sx={{ color: paletteColorsDark.primaryLight, lineHeight: 1.75 }}
      >
        This tour will walk you through setting up your profile so your CE
        credits can be automatically submitted on your behalf.
      </Typography>
    </Box>
  </Stack>
)

export let welcomeToStudioTour: TourDefinition = {
  id: 'welcome-to-studio',
  version: 1,
  name: 'Welcome to Studio',
  description:
    'A quick intro to FOAMfrat Studio and how to set up your profile.',
  allowInLimited: true,
  steps: [
    {
      target: 'body',
      placement: 'center',
      title: 'Welcome to FOAMfrat Studio',
      content: <WelcomeContent />,
      disableBeacon: true,
    },
    {
      target: '[data-tour="profile-menu-button"]',
      placement: 'bottom',
      title: 'Your Profile Settings',
      content:
        "To enable automatic CE submission, you'll need to complete your profile. Click Next and we'll take you there.",
      navigateTo: '/profile',
    },
    {
      target: '[data-tour="profile-account-details-tab"]',
      placement: 'bottom',
      title: 'Account Details',
      content:
        'Start here — fill in your personal information. Your name, address, and contact details are required for The Commission on Accreditation for Prehospital Continuing Education (CAPCE) CE submission.',
    },
    {
      target: '[data-tour="profile-licenses-tab"]',
      placement: 'bottom',
      title: 'Licenses & Certifications',
      content:
        'Next up is your licenses & certifications. Click this tab to continue.',
      spotlightClicks: true,
      navigateTo: '/profile/licenses',
    },
    {
      target: 'body',
      placement: 'center',
      title: 'Your Licenses',
      content: (
        <Stack spacing={1.5}>
          <Typography
            variant="body2"
            sx={{
              color: paletteColorsDark.text,
              lineHeight: 1.75,
              opacity: 0.9,
            }}
          >
            Add your NREMT number and any state licenses / certifications here.
            We currently support automatic CE submission for:
          </Typography>
          <Box
            component="ul"
            sx={{ m: 0, pl: 2.5, color: paletteColorsDark.text, opacity: 0.9 }}
          >
            {[
              'CAPCE',
              'Florida (CE Broker)',
              'Tennessee (CE Broker)',
              'Virginia (VAOEMS)',
              'New Jersey - BLS (NJOEMS)',
            ].map((item) => (
              <Typography
                key={item}
                component="li"
                variant="body2"
                sx={{ lineHeight: 1.75 }}
              >
                {item}
              </Typography>
            ))}
          </Box>
        </Stack>
      ),
    },
  ],
}
